<template xmlns:v-el="http://www.w3.org/1999/xhtml">
    <div>
        <input
            type="file"
            name="form-photo:file"
            style="display: none"
            v-el:file-input
            :accept="this.extensions.join(',')"
            @change="fileChanged"/>
        <div class="form-group pseudo-form" data-name="formPhoto" v-el:block :style="holderStyle" v-if="!headless">
            <!--<image-editor v-ref:image-editor :on-save="imageSaved"></image-editor>-->
            <form-label v-if="hasLabel()" :hint="hint">
                <slot name="label">{{ label }}</slot>
            </form-label>
            <div :class="holderClass()">
                <i :class="iconClass" v-if="iconClass"></i>
                <div class="input-holder">
                    <div v-if="!compact">
                        <div class="thumbnail" :class="{'grid-it': transparent}" @click="triggerInput()"
                             v-if="!hasPreview() && isEmpty()">
                            <img v-if="photo" :src="photoThumbnail">
                            <div class="empty-thumbnail" v-if="!photo" :class="{'grid-self': transparent}">
                                <i class="fa fa-upload" style="font-size: 40px;color: rgba(150, 150, 150, .8);"></i>
                                <br/>
                                {{ placeholder }}

                            </div>
                        </div>
                        <div class="thumbnail" v-if="!hasPreview() && !isEmpty()">
                            <div v-if="model.type === 'image'" :class="{'grid-self': transparent}">
                                <!--<div class="file-type">{{ getTypeName(model.mime) }}</div>-->
                                <div class="file-size">{{ model.size | fileSize }}</div>
                                <div class="fake-image"
                                     :style="{'backgroundImage': `url(${model.extra.thumbnails.large})`}"></div>
                            </div>
                        </div>
                        <div class="thumbnail" v-if="hasPreview() && isEmpty()">
                            <div v-if="preview.image" :class="{'grid-self': transparent}">
                                <!--<div v-if="editable" class="file-edit" @click="showEditor()">-->
                                <!--<i class="fa fa-pencil"></i>-->
                                <!--Editar-->
                                <!--</div>-->
                                <!--<div class="file-type">{{ preview.typeName }}</div>-->
                                <div class="file-size">{{ preview.size | fileSize }}</div>
                                <div class="fake-image"
                                     :style="{'backgroundImage': `url(${preview.uri})`}"></div>
                            </div>
                            <div v-if="!preview.image">
                                <!--<div class="file-type">{{ preview.typeName }}</div>-->
                                <div class="file-size">{{ preview.size | fileSize }}</div>
                                <div class="sixteen-nine">
                                    <div class="content" style="display: flex; align-items: center">
                                        <div class="text-center" style="width: 100%">
                                            <i class="fa fa-file" style="font-size: 50px"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row" v-if="sending">
                        <div class="flex-col-12">
                            <div class="progress">
                                <div v-if="progress >= 0" class="progress-bar" :style="{width: `${progress}%`}">
                                </div>
                                <div v-if="!progress" class="progress-bar progress-bar-striped active"
                                     style="width: 100%">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-row bottom-row btn-group" v-if="!sending">
                        <span class="btn btn-default btn-file flex-col-8" @click="triggerInput()">
                            <i class="fa fa-folder-open"></i>
                            <span v-if="!compact || !preview">
                                <span v-if="isEmpty()">
                                    {{ emptyMessage }}
                                </span>
                                <span v-if="!isEmpty()">
                                    {{ selectedMessage }}
                                </span>
                            </span>
                            <span v-if="compact && preview">
                                {{ preview.name }} ({{ preview.size | fileSize }})
                            </span>
                        </span>
                        <button type="button" class="btn btn-default" v-if="model || preview" @click="clear()">
                            <i class="fa fa-trash"></i>
                        </button>
                        <button type="button" class="btn yellow-gold" v-if="preview" @click="upload()">
                            <i class="fa fa-cloud-upload"></i>
                            Enviar

                        </button>
                    </div>
                    <div :data-field="fieldName"></div>
                </div>
                <slot name="append"></slot>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .bottom-row {
        margin: 0;
    }

    .thumbnail {
        border: 0;
        box-shadow: inset 0px 0px 0px 1px #ccc;
        border-radius: 4px;
        margin: 0;
        padding: 0;
        margin-bottom: 4px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
    }

    .input-holder {
        width: 100%;
        position: relative;
        padding: 0
    }

    .empty-thumbnail {
        width: 100%;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .file-size {
        position: absolute;
        top: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .3);
        color: white;
        padding: 3px;
        border-bottom-left-radius: 4px;
        border-top-right-radius: 4px;
    }

    .file-type {
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, .3);
        color: white;
        padding: 3px;
        border-top-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .file-edit {
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
        color: white;
        padding: 3px;
        border-top-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .fake-image {
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 290px;
    }

    .progress {
        margin: 0;
        height: 34px;
    }
</style>
<script>
    import Input from './generic/input'
    import { mime } from 'sci/std'
    import { client, vueChaos } from 'sci/helpers'

    export default {
        name: 'form-file',
        mixins: [Input],
        components: {
            // ImageEditor: require('./ImageEditor.vue')
        },
        props: {
            maxWidth: {
                type: Number,
                default: null
            },
            emptyMessage: {
                type: String,
                default: 'Selecione um arquivo'
            },
            selectedMessage: {
                type: String,
                default: 'Mudar arquivo'
            },
            namespace: {
                default: null
            },
            transparent: {
                type: Boolean,
                default: false
            },
            onUploaded: {
                default: null
            },
            onProgress: {
                default: null
            },
            types: {
                default: null,
                type: Object
            },
            editable: {
                default: false,
                type: Boolean
            },
            compact: {
                default: false,
                type: Boolean
            },
            headless: {
                type: Boolean,
                default: false
            },
            extensions: {
                type: Array,
                default: () => []
            }
        },
        data () {
            return {
                fieldName: null,
                sent: false,
                sending: false,
                progress: null,
                preview: null
            }
        },
        ready () {
            this.fieldName = this._props.model.raw
        },
        methods: {
            holderStyle () {
                const styles = {}

                if (this.maxWidth) {
                    styles.maxWidth = `${this.maxWidth}px`
                }

                return styles
            },
            hasPreview () {
                return !!this.preview
            },
            isEmpty () {
                return !this.model
            },
            clear () {
                this.model = null
                this.preview = null
            },
            getFile () {
                const files = this.$els.fileInput.files

                if (files.length < 1) {
                    return null
                }

                return files[0]
            },
            setFile (name, uri, type = null) {
                if (uri === null) {
                    return window.Promise.reject()
                }

                return window.Promise.resolve().then(() => {
                    const [/**/, uriType, /**/, data] = uri.split(/data:(.*?);(.*?),/)

                    const mimeType = type || uriType

                    const bin = window.atob(data)
                    const size = bin.length
                    const bytes = new Uint8Array(size)

                    for (let i = 0; i < size; i++) {
                        bytes[i] = bin.charCodeAt(i)
                    }

                    this.preview = {
                        name,
                        mimeType,
                        size,
                        uri,
                        type: mime.fetch(mimeType).name,
                        image: mime.isImage(mimeType),
                        blob: new window.Blob([bytes], { type: mimeType })
                    }

                    if (this.onChanged) {
                        this.onChanged(this.preview)
                    }
                })
            },
            upload () {
                if (this.sending) {
                    return
                }

                if (!this.preview) {
                    return
                }

                this.sending = true
                this.sent = false

                const data = new window.FormData()
                const fileInfo = this.preview

                data.append('file', fileInfo.blob, fileInfo.name)
                data.append('name', fileInfo.name)

                if (this.namespace) {
                    data.append('namespace', this.namespace)
                }

                const request = client
                    .silent()
                    .onProgress((percent) => {
                        this.progress = percent
                        if (this.onProgress) {
                            this.onProgress(percent)
                        }
                    })
                    .post('Salvando imagem...', '/utils/temp-files', data)

                return request
                    .then(vueChaos(this.$els.block))
                    .then((response) => {
                        if (this.onProgress) {
                            this.onProgress(100)
                        }

                        this.clear()

                        this.sending = false
                        this.sent = true

                        this.model = response

                        if (this.onUploaded) {
                            this.onUploaded(response)
                        }

                        return response
                    })
                    .catch((ex) => {
                        this.sending = false
                        this.sent = false

                        throw ex
                    })
            },
            triggerInput () {
                this.$els.fileInput.click()
            },
            fileChanged (e) {
                const file = this.getFile()

                if (!file) {
                    return
                }

                this.clear()

                if (!this.validate(file.type)) {
                    this.preview = null
                    return
                }

                const reader = new window.FileReader()

                reader.onload = (e) => {
                    this.setFile(file.name, e.target.result, file.type)

                    this.$els.fileInput.value = null
                }

                reader.readAsDataURL(file)
            },
            validate (mime) {
                if (this.types === null) {
                    return true
                }

                for (const k of Object.keys(this.types)) {
                    const regexp = new RegExp(k)

                    if (!regexp.test(mime)) {
                        alert(`Arquivo inválido, somente: ${Object.values(this.types).join(', ')}`)
                        return false
                    }
                }

                return true
            },
            showEditor () {
                // this.$refs.imageEditor.show(this.preview.uri)
            },
            imageSaved (data) {
                this.setFile('image.png', data, 'image/png')
            },
            getTypeName (type) {
                return mime.fetch(type).name
            },
            ask () {
                this.triggerInput()
            },
            canUpload () {
                return !!this.preview
            }
        },
        computed: {
            photo () {
                if (this.model) {
                    return this.model.url
                }

                return null
            },
            photoThumbnail () {
                if (this.model) {
                    return this.model.url
                }

                return null
            }
        },
        watch: {
            file (newValue) {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// File.vue?67061e18